import React, { useEffect, useState } from "react";

import { JsonForms } from "@jsonforms/react";
import { materialRenderers, materialCells } from "@jsonforms/material-renderers";
import { Box, Button } from "@mui/material";

import { v3Schema } from "./schemas/edgeConfigSchema";
import { uiSchema } from "./schemas/uiSchema";
import { polarisUiSchema } from "./schemas/polarisUiSchema";
import { polarisSchema } from "./schemas/polarisJsonSchema";

import RangeControl, { rangeControlTester } from "./EdgeConfigRangeControl";
import { log } from "util";

const renderers = [...materialRenderers, { tester: rangeControlTester, renderer: RangeControl }];

const classes = {
    v3root: {
        "& .MuiPaper-elevation1": {
            height: "99%",
        },
    },
    polarisRoot: {
        "& .MuiGrid-root": {
            height: "100%",
        },
        "& .MuiCardContent-root": {
            height: "90%",
        },
        "& .MuiGrid-container": {
            height: "100%",
        },
        "& .MuiPaper-elevation1": {
            height: "100%",
        },
        "& .MuiCard-root": {
            height: "100%",
        },
        "& .MuiButton-root": {
            marginTop: "1rem",
        },
    },
};

function jsonFormtoV3Config(config) {
    // format config from jsonforms to match the format the telemetry api expects
    // would be good to move this into the backend, and eventually make the firmware support new format

    // maxUDP should be equal to numUDP
    config.scan_settings.maxUDP = config.scan_settings.numUDP;

    // server_contact_interval should be equal to the compressed_scan scan_interval
    config.server_settings.server_contact_interval = config.scan_settings.compressed_scan_interval;

    // convert scan settings back into arrays
    let compressed_scan_i = config.scan_settings.algorithm_list.indexOf("compressedScan");
    config.scan_settings.scan_interval[compressed_scan_i] = config.scan_settings.compressed_scan_interval;
    config.scan_settings.scan_interval_offset[compressed_scan_i] = config.scan_settings.compressed_scan_interval_offset;

    return config;
}

function v3ConfigtoJsonForm(config) {
    // format config from jsonforms to match the format the telemetry api expects
    // would be good to move this into the backend, and eventually make the firmware support new format

    let compressed_scan_i = config.scan_settings.algorithm_list.indexOf("compressedScan");
    config.scan_settings.compressed_scan_interval = config.scan_settings.scan_interval[compressed_scan_i];
    config.scan_settings.compressed_scan_interval_offset = config.scan_settings.scan_interval_offset[compressed_scan_i];

    return config;
}

export default function BasicEdgeConfigEditor({
    loading,
    config,
    handleData,
    submitHandler,
    deviceType,
    isDefaultTemplate,
}) {
    const [interfaceSchema, setInterfaceSchema] = useState(null);

    useEffect(() => {
        const disableScroll = (event) => {
            if (
                document.activeElement.type === "number" &&
                document.elementFromPoint(event.x, event.y) === document.activeElement
            ) {
                document.activeElement.blur();
            }
        };

        document.addEventListener("wheel", disableScroll);

        return () => window.removeEventListener("wheel", disableScroll);
    });

    useEffect(() => {
        let schema = uiSchema;
        if (deviceType === "V3" && isDefaultTemplate && config?.edge_device_id) {
            // delete rules that disable editing
            // Edge Device ID
            delete schema.elements[0].elements[0].rule;
            // VLP16 IP Address
            delete schema.elements[1].elements[0].elements[0].rule;
            // Motor Speed
            delete schema.elements[1].elements[0].elements[1].rule;
            // UDP Timeout
            delete schema.elements[1].elements[0].elements[2].rule;
            // Postscan Interval
            delete schema.elements[1].elements[1].elements[1].rule;
        }

        setInterfaceSchema(schema);
    }, [deviceType, config, isDefaultTemplate]);

    if (!loading && deviceType && deviceType === "Polaris" && config?.Gen) {
        return (
            <Box component="div" sx={classes.polarisRoot}>
                <JsonForms
                    schema={polarisSchema}
                    uischema={polarisUiSchema}
                    data={config}
                    renderers={materialRenderers}
                    cells={materialCells}
                    onChange={({ data }) => handleData(data)}
                />
                <Button variant="contained" color="primary" size="medium" onClick={submitHandler}>
                    Save
                </Button>
            </Box>
        );
    }

    if (!loading && interfaceSchema) {
        return (
            <Box component="div" sx={classes.v3root}>
                <JsonForms
                    schema={v3Schema}
                    uischema={interfaceSchema}
                    data={v3ConfigtoJsonForm(config)}
                    renderers={renderers}
                    cells={materialCells}
                    onChange={({ data }) => handleData(jsonFormtoV3Config(data))}
                />
                <Button variant="contained" color="primary" size="medium" onClick={submitHandler}>
                    Save
                </Button>
            </Box>
        );
    }

    return null;
}
